import { Loader } from '@fe-learner-common/components/Loader';
import { SessionDetailsRoute } from '@routes/session-details/SessionDetailsRoute';
import { DetailsPageSkeleton } from '@components/DetailsPageSkeleton';
import { NotFoundError, useAppContext, useConfigContext } from '@fe-core';
import { useParams } from 'react-router-dom';
import { useSessionDetails } from '@hooks/data/useSessionDetails';
import { useError } from '@hooks/useError';
import { publish } from '@fe-core-events';
import { useIntl } from 'react-intl';

export const SessionDetailsRouteLoader = () => {
  const intl = useIntl();
  const { config } = useConfigContext();
  const { sessionId } = useParams();
  const { isLoading: isLoadingAppContext } = useAppContext();
  const emitError = useError();

  const { error, isLoading: isLoadingSessionDetails } = useSessionDetails({
    enabled: true,
    sessionId,
  });

  if (error) {
    if (error instanceof NotFoundError) {
      publish({
        eventName: 'feedback.ui.warning.base',
        data: {
          consumer: 'fe-learner-catalog',
          event: 'feedback.ui.warning.base',
          type: 'modal',
          status: 'warning',

          config: {
            title: intl.formatMessage({
              id: 'catalog.course.error.notfound.title',
              defaultMessage: 'Course not found',
            }),
            description: intl.formatMessage({
              id: 'catalog.course.error.notfound.description',
              defaultMessage: 'This course does not exist.',
            }),
          },
          action: {
            event: `${config.baseUrls.aleweb}catalog`,
            type: 'link' as const,
            text: {
              title: intl.formatMessage({
                id: 'learner.common.close',
                defaultMessage: 'Close',
              }),
            },
          },
        },
      });
      return;
    }

    emitError({
      error: error,
      errorMapOverride: {
        type: 'modal',
      },
    });
  }

  const isLoading = isLoadingAppContext || isLoadingSessionDetails;

  return (
    <Loader isLoading={isLoading} skeleton={<DetailsPageSkeleton />}>
      <SessionDetailsRoute />
    </Loader>
  );
};
